//mainPageAnimation(mainPageFilter) 
const isHomepage = 
  window.location.pathname === "/" || 
  window.location.pathname === "/index.php" ||
  document.body.classList.contains('template-index') ||
  document.body.classList.contains('index');

const desktopQuery = window.matchMedia("(min-width: 1024px)");

if (isHomepage) {
  const shopifySections = document.querySelectorAll(".shopify-section");
  const sections = Array.from(shopifySections).slice(0, 4);
  const maxScroll = 600;
  let ticking = false;

  const updateMargins = () => {

    if (!desktopQuery.matches) {
      sections.forEach(el => {
        el.style.marginLeft = '';
        el.style.marginRight = '';
      });
      ticking = false;
      return; 
    }

    const progress = Math.min(window.scrollY / maxScroll, 1);
    const margin = progress * 12;

    sections.forEach(el => {
      el.style.marginLeft = `${margin}vw`;
      el.style.marginRight = `${margin}vw`;
    });

    ticking = false;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(updateMargins);
      ticking = true;
    }
  });

  updateMargins();
}


//CollectionFinder(mainPageFilter)
class CollectionFinder {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    this.brandSelect = this.container.querySelector('#BrandSelect');
    this.deviceSelect = this.container.querySelector('#DeviceSelect');
    this.submitBtn = this.container.querySelector('#FinderSubmit');
    this.data = JSON.parse(this.container.querySelector('[type="application/json"]').textContent);

    this.brandSelect.addEventListener('change', () => this.updateModels());
    this.deviceSelect.addEventListener('change', () => this.toggleButton());
    this.submitBtn.addEventListener('click', () => this.goToCollection());
  }

  updateModels() {
    const selectedBrandIndex = this.brandSelect.value;
    const models = this.data[selectedBrandIndex] || [];
    
    // Reset and Populate Models
    this.deviceSelect.innerHTML = '<option value="">Select Model</option>';
    models.forEach(model => {
      const opt = document.createElement('option');
      opt.value = model.url;
      opt.textContent = model.title;
      this.deviceSelect.appendChild(opt);
    });

    this.deviceSelect.disabled = models.length === 0;
    this.toggleButton();
  }

  toggleButton() {
    this.submitBtn.disabled = !this.deviceSelect.value;
  }

  goToCollection() {
    const url = this.deviceSelect.value;
    if (url) window.location.href = url;
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFinder('CollectionFinder-{{ section.id }}');
});


// scroll
  let lastScrollTop = 0;
  const header = document.querySelector('.section-header');

  window.addEventListener('scroll', function () {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      // Scrolling DOWN → hide header
      header.classList.add('is-hidden');
    } else {
      // Scrolling UP → show header
      header.classList.remove('is-hidden');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // prevent negative
  });

  /*//accessibiilty-control-button-sequences

(function () {
  var blockId = 'shopify-block-AZ1Zsckk1cGh4UzFFQ__15551562133269743879';
  var hasMovedFocus = false;

  function getAccessibilityButton() {
    var block = document.getElementById(blockId);
    if (!block) return null;

    return block.querySelector('.widget-icon, button[aria-label="Enable accessibility"]');
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    if (event.shiftKey) return;
    if (hasMovedFocus) return;

    var button = getAccessibilityButton();
    if (!button) return;

    hasMovedFocus = true;
    event.preventDefault();

    button.focus();
  }, true);
})();*/